import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { userConstants } from '../../../locale/userTexts';
import '../../RespondentFormReadonly/index.scss';

export default function FormQuestion({
  index, questionText, description, imageUrl, isRequired, examples, totalCount, language, displayIndex,
  hideProgress,
}) {
  const isV2Override = displayIndex !== undefined;
  const questionNum = isV2Override ? displayIndex : index + 1;
  const progressPct = totalCount > 0 ? Math.min((questionNum / totalCount) * 100, 100) : 0;

  return (
    <>
      <Grid
        container
        wrap="nowrap"
        direction="column"
        spacing={2}
        item
        xs={12}
        md={12}
      >
        {!hideProgress && (
          <Grid item className={`questIndex_container${isV2Override ? ' questIndex_container--v2' : ''}`}>
            <Typography className="questIndex">{isV2Override ? `${userConstants(language).question} ${questionNum} ${userConstants(language).of} ${totalCount}` : `${userConstants(language).question} #${questionNum} ${userConstants(language).of} ${totalCount}`}</Typography>
            {isV2Override && (
              <div className="question-progress-bar">
                <div className="question-progress-fill" style={{ width: `${progressPct}%` }} />
              </div>
            )}
          </Grid>
        )}
        <Grid item xs>
          <Typography className={`questionText${isV2Override ? ' questionText--v2' : ''}`}>
            {questionText}
          </Typography>
        </Grid>
      </Grid>
      {imageUrl && <img src={imageUrl} alt="img" className="question-image" />}
    </>
  );
}
